import styled, { css } from 'styled-components'

export const KioskContent = styled.div`
    padding: 0.5em;
    text-align: left;

    ${props =>
        props.isMonoKiosk &&
        css`
            height: 60%;
            /* margin: 0 auto; */
        `}
`

export const KioskHeader = styled.div`
    width: 100%;
    height: 95px;
    margin-bottom: 1em;
    background-image: url(${({ backgroundImage }) => backgroundImage});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    img {
        height: 95px;
        width: 100%;
        object-fit: cover;
    }
    span img {
        position: absolute;
        left: 25px;
        top: 0;
        width: auto;
        height: 116px;
    }
`

export const RecipeTitle = styled.div`
    font-size: 1.3em;
    text-align: left;
    grid-column: 1;
    font-weight: 600;

    color: ${_ => _.theme.recipe_title_font_color};
`

export const RecipeItem = styled.div`
    display: grid;
    grid-template-columns: 1fr auto auto;
    grid-gap: 4px;
    margin: 20px 0;
    margin-top: 30px;
    padding: 0.5em 1em;
    border-bottom: 1px solid ${_ => _.theme.recipe_border_color};


    ${props => props.customStyle === 'produit_neo' && `
        border: 1px solid #003f45;
        border-radius: 12px;
        border-width: 2px;
        margin-top: 46px;
        ${RecipeTitle} {
            color: #003f45;
        }
        ${RecipePoints} {
            & > span {
                color: #003f45;
                border-color: #003f45;
            }
        }
        ${RecipePrice} {
            & > span {
                background-color: #003f45;
                border-color: #003f45;
            }
        }
    `}
`

export const RecipePrice = styled.div`
    grid-column: 3;

    & > span {
        display: inline-block;
        border-radius: 5px;
        min-width: 50px;
        text-align: center;
        font-size: 1.2em;
        font-weight: 700;
        padding: 2px;

        color: ${_ => _.theme.recipe_price_font_color};
        background-color: ${_ => _.theme.recipe_price_background};
        border: 1px solid ${_ => _.theme.recipe_price_background};

        ${props => props.mode === 'print' && css`
            color: ${_ => _.theme.print_recipe_price_font_color || _.theme.recipe_price_font_color};
            background-color: ${_ => _.theme.print_recipe_price_background || _.theme.recipe_price_background};
            border: 1px solid ${_ => _.theme.print_recipe_price_background || _.theme.recipe_price_background};
        `}

        span {
            font-size: 0.6em;
            vertical-align: top;
            display: inline-block;
            margin-top: 3px;
        }
    }
`

export const RecipePoints = styled.div`
    grid-column: ${_ => (_.fullWidth ? '2 span' : _.endPosition ? '3' : '2')};

    & > span {
        display: inline-block;
        border-radius: 5px;
        min-width: 50px;
        text-align: center;
        font-size: 1.2em;
        font-weight: 700;
        padding: 2px;

        color: ${_ => _.theme.recipe_points_font_color};
        background-color: ${_ => _.theme.recipe_points_background};
        border: 1px solid ${_ => _.theme.recipe_points_font_color};

        ${props => props.mode === 'print' && css`
            color: ${_ => _.theme.print_recipe_points_font_color || _.theme.recipe_points_font_color};
            background-color: ${_ => _.theme.print_recipe_points_background || _.theme.recipe_points_background};
            border: 1px solid ${_ => _.theme.print_recipe_points_background || _.theme.recipe_points_font_color};
        `}

        span {
            font-size: 0.6em;
            vertical-align: top;
            display: inline-block;
            margin-top: 3px;
        }
    }
`

export const EnergyKCal = styled(RecipePoints)`
    grid-column: 2 / 2 span;
    & > span {
        max-height: 24px;
        min-width: 100%;
        font-size: 1em;
        border: none;
    }
`

export const RecipeComposition = styled.div`
    font-size: 0.8em;
    font-weight: 300;
    grid-column: 3 span;
    text-align: left;
`

export const RecipeLabels = styled.div`
    grid-column: 1;
    text-align: left;
    margin-bottom: 2px;
`
export const RecipeLabel = styled.img`
    height: 36px;
    vertical-align: middle;
    margin: 0 .1em 10px .1em;
`